import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const CampusTours = () => {
  return (
    <PlaceholderPage title="Campus Tours">
      Schedule a visit to our beautiful campus and experience life at FIC College firsthand. We offer both in-person and virtual tour options.
    </PlaceholderPage>
  );
};

export default CampusTours;
